import YesNoPreference from "./YesNoPreference";
export default YesNoPreference;
